var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinish(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-81"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.18,117.6c21.3,1.09,42.83,9.39,57.52,22,46.68,39.91,40.22,110.84,5.81,156.19-33.82,44.58-91.54,70.06-147.13,68A153,153,0,0,1,174.59,354c-27.05-10.33-62.88-30.25-73.29-59.11C88.78,260.17,125,253.17,149.14,262c19.42,7.12,39,19.43,60.05,9.57,23.33-10.91,35.2-36.06,36.4-60.82,1.3-26.77-13.13-55.71,10.43-77.1C269.65,121.32,288.33,116.64,307.18,117.6Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.18,117.6c21.3,1.09,42.83,9.39,57.52,22,46.68,39.91,40.22,110.84,5.81,156.19-33.82,44.58-91.54,70.06-147.13,68A153,153,0,0,1,174.59,354c-27.05-10.33-62.88-30.25-73.29-59.11C88.78,260.17,125,253.17,149.14,262c19.42,7.12,39,19.43,60.05,9.57,23.33-10.91,35.2-36.06,36.4-60.82,1.3-26.77-13.13-55.71,10.43-77.1C269.65,121.32,288.33,116.64,307.18,117.6Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-81"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-81",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Finish--inject-81"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 76,
    width: 5,
    height: 306,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 76,
    width: 5,
    height: 306,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267 76 267 247.75 262 245.31 262 76 267 76",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 76,
    width: 5,
    height: 341,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 76,
    width: 5,
    height: 341,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83 76 88 76 88 157.8 83 155.36 83 76",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.88,
    y: 78.06,
    width: 188.82,
    height: 53.95,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.88,
    y: 78.06,
    width: 188.82,
    height: 53.95,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.88,
    y: 118.52,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.88,
    y: 91.55,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.36,
    y: 105.03,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.85,
    y: 118.52,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.36,
    y: 78.06,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.85,
    y: 91.55,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.34,
    y: 105.03,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.83,
    y: 118.52,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.34,
    y: 78.06,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.83,
    y: 91.55,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.31,
    y: 105.03,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.8,
    y: 118.52,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.31,
    y: 78.06,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.8,
    y: 91.55,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.29,
    y: 105.03,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.77,
    y: 118.52,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.29,
    y: 78.06,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.77,
    y: 91.55,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.26,
    y: 105.03,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.75,
    y: 118.52,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.26,
    y: 78.06,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.75,
    y: 91.55,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.23,
    y: 105.03,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.72,
    y: 118.52,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.23,
    y: 78.06,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.72,
    y: 91.55,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.21,
    y: 105.03,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.21,
    y: 78.06,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.88,
    y: 118.52,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.88,
    y: 91.55,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.36,
    y: 105.03,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.85,
    y: 118.52,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.36,
    y: 78.06,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.85,
    y: 91.55,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.34,
    y: 105.03,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.83,
    y: 118.52,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.34,
    y: 78.06,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.83,
    y: 91.55,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.31,
    y: 105.03,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.8,
    y: 118.52,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.31,
    y: 78.06,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.8,
    y: 91.55,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.29,
    y: 105.03,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.77,
    y: 118.52,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.29,
    y: 78.06,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.77,
    y: 91.55,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.26,
    y: 105.03,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.75,
    y: 118.52,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.26,
    y: 78.06,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.75,
    y: 91.55,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.23,
    y: 105.03,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.72,
    y: 118.52,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.23,
    y: 78.06,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.72,
    y: 91.55,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.21,
    y: 105.03,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.21,
    y: 78.06,
    width: 13.49,
    height: 13.49,
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-81"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266,176a11.19,11.19,0,0,0-11.52-6.35c-9,.83-17.67,12.16-25.83,9.83S221.5,172,221.5,172s-3,7.39,7.17,13.6,24-9.46,35.48-4.8Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,176a14.65,14.65,0,0,0-12.52-9.39c-9.62-.75-15.25,11.41-22.62,9.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48002599999999995px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.12,189.65s3.42-14.12-8.43-17-17.19,4.1-19.19,11.79,3,18.4,13.77,16.63S287.69,193,288.12,189.65Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.51,211.59c9.74-4.53,22.54-14.45,22.3-18.06s-10.06-27.9-10.06-27.9a7.65,7.65,0,0,1-2.26-1.08c-1-.72-2.17-9.66-.72-10.14a44.09,44.09,0,0,1,7.49-1.21c1.2,0,.72,8,.24,9.9,0,0,15.58,21.72,14.55,32.12s-25.18,28.47-33.63,31S292.51,211.59,292.51,211.59Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.81 329.9 189.57 324.02 198.2 326.9 206.12 329.56 203.98 337.07 194.88 333.28 186.81 329.9",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.54,322.94c.64.32-3.61,8-3.61,8s-7.29,2.56-10.64,6.79-5,.23-2.46-5.09L180,319.53C181.79,315.75,183.89,319.63,190.54,322.94Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.72,335.61a.55.55,0,0,1-.18,0,.84.84,0,0,1-.76-.59c-.28-1.1,2.2-3.2,2.7-3.61a.19.19,0,0,1,.1-.05h0s0,0,0,0h0a.34.34,0,0,1,.14.05h0l0,0h0c.07.07,1.61,1.61,1.55,2.9a1.37,1.37,0,0,1-.51,1,.8.8,0,0,1-.92.2c-.4-.22-.56-1-.6-1.79a3.62,3.62,0,0,1-1,1.69A1,1,0,0,1,183.72,335.61Zm1.55-3.43c-1.05.94-2.17,2.19-2,2.71,0,0,.05.18.4.25a.5.5,0,0,0,.38-.1C184.61,334.62,185.05,333.16,185.27,332.18Zm.54-.07c-.11,1.39,0,2.82.33,3,.1.06.29-.08.39-.16a.9.9,0,0,0,.35-.68A3.92,3.92,0,0,0,185.81,332.11Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.7 333.19 198.04 326.83 206.04 329.52 203.94 337.05 194.7 333.19",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.12,290.82c-3.62,15.68-19.81,69.19-45,67.19S199.5,342.15,199,335.83s1.44-9.8,7.72-9.82,24.71,5.64,32.74,5.07S255,296.41,255,296.41Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.12,290.82c-3.62,15.68-19.81,69.19-45,67.19S199.5,342.15,199,335.83s1.44-9.8,7.72-9.82,24.71,5.64,32.74,5.07S255,296.41,255,296.41Z",
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.37 403.04 346.4 405.62 341.84 397.74 337.66 390.51 344.24 386.3 348.54 395.16 352.37 403.04",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,405.79c-.27-.66,8-3.64,8-3.64s7.15,2.91,12.47,2,3.87,3.11-1.53,5.44l-13.34,5.76C346.76,417,347.75,412.67,345,405.79Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,402.91a5.6,5.6,0,0,0-.61.09h-.13a.68.68,0,0,1-.21-.11v-.08a.08.08,0,0,0,0-.06s0,0,0-.06h0s.05-.06.05-.09h0c0-.09-.11-2.27.79-3.2a1.33,1.33,0,0,1,1.07-.42q.68,0,.84.45c.16.43-.23,1.1-.74,1.74a3.68,3.68,0,0,1,1.9-.59,1,1,0,0,1,.67.36.93.93,0,0,1,.18,1C358.33,402.75,356.12,402.91,355,402.91Zm2.8-1.88a6.36,6.36,0,0,0-2.73,1.32c1.41,0,3.08-.21,3.33-.68,0,0,.08-.17-.13-.45a.47.47,0,0,0-.36-.18Zm-1.87-2c-.27,0-.49.31-.67.5a4.1,4.1,0,0,0-.63,2.44c1-1,1.88-2.26,1.74-2.63a.6.6,0,0,0-.4-.31Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.62 395.35 341.91 397.91 337.69 390.59 344.26 386.34 348.62 395.35",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.71,259.72s-14,20.78-11.11,36.26C250,314.25,294,334.82,306,343.91s17.62,43.42,32.56,50l8.13-2.91s4.14-5.72,1.05-15.45c-13-40.8-23.74-60.3-59.62-84.73,0,0,2.36-19.78,1.37-29.8Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.71,259.72s-14,20.78-11.11,36.26C250,314.25,294,334.82,306,343.91s17.62,43.42,32.56,50l8.13-2.91s4.14-5.72,1.05-15.45c-13-40.8-23.74-60.3-59.62-84.73,0,0,2.36-19.78,1.37-29.8Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.38,392.54l-2,.72c-4.54-5.78-8.25-16.2-12.14-27.14-4.13-11.59-8.4-23.57-13.43-28.33-3.5-3.31-11.26-8.52-20.25-14.56-18.35-12.33-39.16-26.3-40.55-34.82-1.47-9.06,3.16-22,5.93-28.6l2.14.09c-2.63,6.23-7.53,19.41-6.09,28.19,1.25,7.66,23.46,22.59,39.68,33.48,9.07,6.09,16.89,11.34,20.52,14.77,5.37,5.09,9.53,16.75,13.93,29.11C333.92,376.12,337.84,387.13,342.38,392.54Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.12,290.82S280.75,286,271.5,280L285,285.41a55.44,55.44,0,0,0,4.71-19.48A236.85,236.85,0,0,1,288.12,290.82Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.71,259.72l32,3.28s7.63-29.4,7.82-54.08c0,0-12.26,4-23.28,2.66s-20.77-7.08-20.77-7.08S258.67,236.69,257.71,259.72Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.46,218c-7.62-2-9.53-5.58-9.53-5.58,5.51-4,2.45-12.57,2.45-12.57l9.11,2.93a26.07,26.07,0,0,0-.87,3.88c-.79,5.65,1.76,6,1.76,6C281.62,216,277.46,218,277.46,218Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.49,202.78a26.07,26.07,0,0,0-.87,3.88c-6.3-.81-8.24-6.81-8.24-6.81Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.66,176.05c8.16.59,10.47,5.15,10.46,13.6,0,10.57-2.88,17.87-12.93,14.89C261.55,200.48,264.1,175.07,277.66,176.05Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.88,188.82a16.91,16.91,0,0,0,2.13,3.55,2.26,2.26,0,0,1-2.22.77Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.93,187.79c0,.67-.42,1.19-.87,1.17s-.78-.58-.75-1.25.42-1.2.87-1.18S278,187.11,277.93,187.79Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,186.55l1.49-.5S277.69,187.25,277,186.55Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.29,188.05c0,.68-.43,1.2-.87,1.18s-.79-.58-.76-1.25.43-1.2.87-1.18S286.32,187.38,286.29,188.05Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.35,186.82l1.48-.5S286.05,187.51,285.35,186.82Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.26,182.14a4.27,4.27,0,0,0-3.63,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.6957300000000001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.21,182.23a3.84,3.84,0,0,1,3.21.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.6957300000000001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.37,196.27a19.93,19.93,0,0,0-1.16,2.76,4.34,4.34,0,0,1-.52-.09c-2.36-.41-3.32-1.38-3.67-2.33a3.25,3.25,0,0,1-.13-1.45,2.92,2.92,0,0,1,.21-.81,11.4,11.4,0,0,0,4.46,1.76C281.05,196.22,281.37,196.27,281.37,196.27Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.56,196.11l-.36.81c-2.22-.39-3.73-1-4.31-1.76a2.92,2.92,0,0,1,.21-.81A11.4,11.4,0,0,0,280.56,196.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.69,198.94c-2.36-.41-3.32-1.38-3.67-2.33a7.62,7.62,0,0,1,2.53,1A2.85,2.85,0,0,1,279.69,198.94Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.74,189.16s4.3-6.43,4.1-11.65c0,0,16.65-5.44,16.26,11,0,0,2.64-14.47-11.37-15.81s-15.43,19.2-8.63,25.84C268.1,198.58,265.08,193.18,267.74,189.16Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,191a3.59,3.59,0,0,0-3.62-3.55c-2.55.09-4.13,5.2,2.07,6.9C268.29,194.57,268.87,193.73,269,191Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.5,204.5s5.74,9.65,2.63,20.12c0,0-22.13-24.63-24.13-30.25s12.41-37.62,12.41-37.62S242,150,242.5,148.5s6.75-5,8.25-4,1,12,.25,13.5l-.75,1.5s-7.7,29-6.73,31.11S253.5,204.5,253.5,204.5Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.13,176s-8.76,13.12-20.39,11c0,0-.57-9.94,7.21-12.12A17.63,17.63,0,0,1,282.13,176Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.56,176s3.65,5.48-6.29,9.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48002599999999995px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.37,175.61s4.19,3.84,5.92-1.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.48002599999999995px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.09,252.66l.91-1.53s-1.12-.34-3.06-.79c.82-5.59,3.33-26.74-2.8-40.46l-1.14.87s2.84,4.35,3.13,12.88l-21.2-.13s-2.43-11.87-5.44-15.52l-.76.35a88.34,88.34,0,0,1,4.46,39.91,62,62,0,0,0-9.94,1.39l.81,1.5a123.63,123.63,0,0,1,18-.72l11.14,1C288.17,251.75,290.16,252.15,292.09,252.66Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.09,252.66l.91-1.53s-1.12-.34-3.06-.79c.82-5.59,3.33-26.74-2.8-40.46l-1.14.87s2.84,4.35,3.13,12.88l-21.2-.13s-2.43-11.87-5.44-15.52l-.76.35a88.34,88.34,0,0,1,4.46,39.91,62,62,0,0,0-9.94,1.39l.81,1.5a123.63,123.63,0,0,1,18-.72l11.14,1C288.17,251.75,290.16,252.15,292.09,252.66Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.51,239.12a4,4,0,0,1-.82,2.71,3.21,3.21,0,0,1-2.54.93,3.13,3.13,0,0,1-2.45-.91,3.73,3.73,0,0,1-.83-2.61v-.36H275v.5a1.46,1.46,0,0,0,.31,1.07,1.11,1.11,0,0,0,.83.31,1.13,1.13,0,0,0,.9-.36,2.12,2.12,0,0,0,.32-1.36v-2.56a2.07,2.07,0,0,1-2,1.24,2.13,2.13,0,0,1-1.83-.82,3.91,3.91,0,0,1-.61-2.38V232a3.68,3.68,0,0,1,.86-2.61,3.83,3.83,0,0,1,5,0,3.68,3.68,0,0,1,.86,2.61Zm-3.34-3.4a1.11,1.11,0,0,0,.83-.31,1.46,1.46,0,0,0,.31-1.07v-2.52a1.44,1.44,0,0,0-.31-1.06,1.3,1.3,0,0,0-1.66,0,1.44,1.44,0,0,0-.31,1.06v2.52a1.46,1.46,0,0,0,.31,1.07A1.11,1.11,0,0,0,276.17,235.72Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.43,239.12a4,4,0,0,1-.82,2.71,3.21,3.21,0,0,1-2.54.93,3.13,3.13,0,0,1-2.45-.91,3.73,3.73,0,0,1-.83-2.61v-.36h2.08v.5a1.46,1.46,0,0,0,.31,1.07,1.11,1.11,0,0,0,.83.31,1.13,1.13,0,0,0,.9-.36,2.12,2.12,0,0,0,.32-1.36v-2.56a2.07,2.07,0,0,1-2,1.24,2.13,2.13,0,0,1-1.83-.82,3.91,3.91,0,0,1-.61-2.38V232a3.68,3.68,0,0,1,.86-2.61,3.83,3.83,0,0,1,5,0,3.68,3.68,0,0,1,.86,2.61Zm-3.34-3.4a1.11,1.11,0,0,0,.83-.31,1.46,1.46,0,0,0,.31-1.07v-2.52a1.44,1.44,0,0,0-.31-1.06,1.3,1.3,0,0,0-1.66,0,1.44,1.44,0,0,0-.31,1.06v2.52a1.46,1.46,0,0,0,.31,1.07A1.11,1.11,0,0,0,284.09,235.72Z",
    style: {
      fill: "#19A49C"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ribbon--inject-81"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437,234c-2-.66-39-16.11-86.9-1.59-12.45,3.77-25.65,8.54-38.41,13.16l-10.38,3.74c-1.94.69-5.37,2-5.66,4l3.14,7.54c6.44-2.24,9.69-3.46,16.3-5.85,12.64-4.57,25.72-9.3,37.92-13a131.67,131.67,0,0,1,73.76-.9l2.73-1.75L428.17,237h3.67l-3.67-3H437Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.83,263s16.92.78,22.34,3.83l.16-8.2s-.08-.5-1.61-.53c-5.22-.11-16.67-1.13-19.37-2.54-6.14-3.19,2.8-6.2,2.8-6.2s-5.65,1.77-5.5,3.91C295.65,253.27,297.33,259.42,296.83,263Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.83,263s16.92.78,22.34,3.83l.16-8.2s-.08-.5-1.61-.53c-5.22-.11-16.67-1.13-19.37-2.54-6.14-3.19,2.8-6.2,2.8-6.2s-5.65,1.77-5.5,3.91C295.65,253.27,297.33,259.42,296.83,263Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.84,267.13a1.6,1.6,0,0,1-1.1,1.89,56.25,56.25,0,0,1-15.67,2c-22.72,0-51.21-10.3-81-21.08-12.64-4.57-25.72-9.3-37.92-13a131.67,131.67,0,0,0-73.76-.9l-2.73-1.75L110,232h-3.67l3.67-3h-9c2-.66,39.07-16.11,87-1.59,12.46,3.77,25.7,8.54,38.46,13.16,34.6,12.52,73.25,23.26,91.6,18.51,1.17-.3,1.06-.62.76-.79a1.5,1.5,0,0,0-.48-.14c.88.05,1,.4,1.06.72A63,63,0,0,0,320.84,267.13Z",
    style: {
      fill: "#19A49C"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinish);
export default __webpack_public_path__ + "static/media/finish.02077fdf5e5cf7dde4ce73b83e66521f.svg";
export { ForwardRef as ReactComponent };